import React from 'react'
// import Ctalogo from '../../../assets/images/dinesh.png';
import Ctalogo from '../../../assets/images/jitender.jpeg';
import { Link } from 'react-router-dom';

const Ctaone = () => {
    return (
        <section className="cta-one" style={{ paddingTop: 24 }}>
            <div className="container">
                <div className="text-center mb-4" style={{ marginTop: 32 }}>
                    <h1 style={{ fontWeight: 500, fontSize: '2.5rem', marginBottom: 0 }}>
                       
                    
                    </h1>
                <div>    
                    {/* <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: 'inline',
                    }}/>
                        <span style={{
                            display: 'inline',
                            position: 'absolute',
                            left: '50%',
                            top: -16,
                            transform: 'translateX(-50%)',
                            background: '#fff',
                            padding: '0 12px',
                            fontSize: 24,
                            letterSpacing: 8
                        }}>
                            ★★★
                        </span>
                        <div style={{
                        width: 170,
                        margin: '12px auto 0 auto',
                        borderBottom: '2px solid #222',
                        position: 'relative',
                        height: 24,
                        display: "inline"
                    }}/> */}
                    
                    
                </div>    
                </div>
                {/* <div className="row justify-content-center align-items-start" id='justify-content' style={{ marginTop: 34 }}>
                    <div className="col-lg-7 col-md-8 col-12 px-4" style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: 18, lineHeight: 1.7, maxWidth: 700 }}>
                            <p className='mb-3'>
                                <span style={{ fontWeight: 600, fontSize: 22 }}>Dear friends,</span>
                            </p>
                            <p>
                                As NRI’s, when we move to a new country, we still want to keep our relationship with our home Country, India, 
                            </p>
                            <ol className='features-one-list1 my-2 py-2 px-2' >
                                <li><b>1.</b> For emotional reasons </li>
                                <li><b>2.</b>  We are not sure how our life would be in the new country.</li>                               
                            </ol>
                            <p>
                                Over the period of time, our life starts settling down in our new country. 
                            </p>
                            <p>
                                For emotional reasons, we wants to keep our relationship with our home country. India. However, practically, it starts becoming challenging.  We then start reaching out to our friends and extended family members seeking their assistance for managing our interests.  While the friends and extended family members have the best interest to support us, sometime it becomes challenging for them due to their personal situations and also they may not have the expertise. This then results in sleepless nights for us here in Canada, where inspite of our best intentions of keeping our relationships with India, we start looking for options.
                            </p>
                            <p>
                                I have had the similar situation during my early days in Canada, when two of my properties in India were involved in legal challenges. My family in India tried to support me to the best of their abilities.  However, due to their own commitments and lack of knowledge on how to navigate the system, I had to travel to India few times on an urgent basis to address the issues.
                            </p>
                            <p>At that time, I thought I wish there was a “professional organization”, who could represent me and take care of my interest in India. Unfortunately, I couldn’t find any such organization at that time. I am sure, some of you have the similar story to share</p>
                            <p>This is why, we are building <strong>“NRI Advisor Canada Operations”.</strong> Supported by a team of professionally qualified individuals, we intend to build a “one stop solution” for all your needs in India.</p>
                            <p><strong>Transparency, Trust & Credibility are the core values on which we are building NRI Advisor Canada Operations.</strong></p>
                            <p>Please reach out to us and let’s support you in living a<strong> “Stress Free life” </strong>in Canada knowing that your interests in India are well taken care.</p>
                            
                            <p style={{ fontWeight: 600, marginTop: 32, marginBottom: 0 }}>
                                Regards,<br />
                                Dinesh Sharma<br />
                                <span style={{ fontWeight: 400 }}>Head – Canada Operations – The NRI Advisors</span>
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-10 d-flex justify-content-center" style={{ minWidth: 320 }}>
                        <img
                            src={Ctalogo}
                            alt="Vivek Aggarwal"
                            style={{
                                width: 420,
                                height: 380,
                                objectFit: 'cover',
                                borderRadius: 4,
                                marginLeft: 24,
                                boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
                            }}
                        />
                    </div>
                </div> */}

                <div className="row justify-content-center align-items-start" id='justify-content' style={{ marginTop: 34 }}>
                    <div className="col-lg-7 col-md-8 col-12 px-4" style={{ textAlign: 'left' }}>
                        <div style={{ fontSize: 18, lineHeight: 1.7, maxWidth: 700 }}>
                            <p style={{ textAlign: "justify"}}>
                                Jitender Luthra is the Chief Operating Officer of THE NRI Advisors Canada, bringing more than 25 years of distinguished leadership across the public sector, global technology, and international professional services. His career has been defined by the ability to lead complex transformation, strengthen operating models, and deliver measurable outcomes across highly regulated, multi-stakeholder environments. 
                            </p>
                            <p style={{ textAlign: "justify"}}>
                                He brings deep expertise across Corporate Governance & Compliance, Financial Strategy & Capital Allocation, Capital Markets & Funding Structures, M&A Transactions & Integration, Talent & Board Development, Corporate Administration & Operations, and Enterprise Risk Oversight. He has guided cross-functional teams of 200+ through large-scale, multi-country initiatives—converting strategic complexity into disciplined execution, regulatory challenges into competitive advantage, and long-term vision into measurable outcomes that endure.
                            </p>
                            <p style={{ textAlign: "justify"}}>
                                In his role at THE NRI Advisors, Jitender brings that same leadership to a mission far closer to his heart: championing the interests of the global NRI community. Wherever in the world an NRI may be — managing cross-border wealth, navigating property and investment decisions back home, planning for the future of their family, or building a business that spans continents — the questions they face are rarely simple, and the stakes are always personal. Jitender's role is to ensure that THE NRI Advisors meets every one of those individuals with the expertise, clarity, and dedication they deserve. Under his leadership, Canada Operations is built on a single conviction: that the global NRI community deserves a trusted partner who understands their world completely — and is fully committed to helping them protect, grow, and honour everything they have worked for.
                            </p>
                            
                            <p style={{ fontWeight: 600, marginTop: 32, marginBottom: 0 }}>
                                Regards,<br />
                                Jitender Luthra<br />
                                <span style={{ fontWeight: 400 }}>Chief Operating Officer – The NRI Advisors</span>
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-4 col-10 d-flex justify-content-center" style={{ minWidth: 320 }}>
                        <img
                            src={Ctalogo}
                            alt="Vivek Aggarwal"
                            style={{
                                width: 420,
                                height: 380,
                                objectFit: 'cover',
                                borderRadius: 4,
                                marginLeft: 24,
                                boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Ctaone;